import { AUTHORITY_KIND_INFO, type AuthorityKind, type HospitalAuthorityView } from './accounts-types';
import { tr } from '@/lib/i18n-core';
import { money } from '@/lib/utils';

export function parsePercent(text: string): number | null {
  const cleaned = text.trim().replace(',', '.');
  if (cleaned === '') return null;
  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
}

export function parseAmountMinor(text: string): number | null {
  const cleaned = text.trim().replace(/\s/g, '').replace(',', '.');
  if (cleaned === '') return null;
  const value = Number(cleaned);
  return Number.isFinite(value) && value >= 0 ? Math.round(value * 100) : null;
}

export function valueLabel(kind: AuthorityKind, value: { value: number | null; unlimited?: boolean; dormant?: boolean }): string {
  if (value.dormant) return 'no permission';
  const info = AUTHORITY_KIND_INFO[kind];
  if (info.value === 'pct') return `${value.value ?? 0}%`;
  if (value.value === null || value.unlimited) return info.unsetMeansNoLimit ? 'no limit' : 'none';
  return money(value.value);
}

export function thresholdLabel(minor: number | null): string {
  return minor === null ? 'No threshold' : money(minor);
}

export function hospitalSummary(hospital: HospitalAuthorityView): string[] {
  return [
    `Supplier payments: ${thresholdLabel(hospital.supplierPaymentMinor)}`,
    `Write-offs: ${thresholdLabel(hospital.stockAdjustMinor)}`,
    `Counter returns: ${thresholdLabel(hospital.posReturnMinor)}`,
  ];
}

export interface ShareRateValue {
  sharePct: number | null;
  shareMinor?: number | null;
}

export type ShareRateKind = 'pct' | 'fixed';

export function shareRateKind(value: ShareRateValue | null | undefined): ShareRateKind {
  return value && value.sharePct === null && value.shareMinor !== null && value.shareMinor !== undefined ? 'fixed' : 'pct';
}

export function shareRateText(value: ShareRateValue | null | undefined, none: string): string {
  if (!value) return none;
  if (value.sharePct !== null) return `${value.sharePct}%`;
  if (value.shareMinor !== null && value.shareMinor !== undefined) return tr('billing', 'x_per_unit', { amount: money(value.shareMinor) });
  return none;
}
